/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enAU = Object.assign(TranslationProviderComponent, {
  translations
});

export { enAU as e };
//# sourceMappingURL=en-AU-BG6RAFGx.js.map
